import styled from '@emotion/styled';
import DaumPostcode from 'react-daum-postcode';


interface ISearchAddressModal {
  showModal: boolean;
  closeModal: () => void;
  handleComplete: (data: any) => void;

}

const SearchAddressModal:React.FC<ISearchAddressModal> = ({ showModal, closeModal, handleComplete }) => {
  // const handleAddressComplete = (data: any) => {
  //   handleComplete(data);
  //   closeModal(); // 주소 선택 후 모달 닫기
  // };
  return (
    <>
    {showModal? <Background onClick={closeModal}>
        <ModalContainer onClick={e => e.stopPropagation()}>
          <DaumPostcode onComplete={handleComplete} />
        </ModalContainer>
      </Background>:null}
    </>
  )
};

export default SearchAddressModal;

const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContainer = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  position: relative;
  width: 400px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
`;

// const CloseButton = styled.button`
//   position: absolute;
//   top: 10px;
//   right: 10px;
//   background: transparent;
//   border: none;
//   font-size: 24px;
//   cursor: pointer;
// `;